<template>
    <SectionViewLayout
        title='settings.blacklist.title.main'
        :content_state='antispam_controller.content_state'
        content_class="anti-spam"
        close_route="settings"
    >
        <template #actions>
            <ActionButton
                @click="onSearchToggle()"
                v-tooltip='"settings.blacklist.actions.search"'
                icon='fas fa-search'
                :class="{'active' : search_active}"
            />
            <RouterButton v-if='disable_add === false'
                link='/settings/blocked_emails/add'
                v-tooltip='"settings.blacklist.actions.add"'
                icon="fas fa-plus-circle"
            />
        </template>

        <template #pre_content>
            <InputSearch v-if="search_active"
                ref="input_search_component"
                class="contacts-search"
                @inputSearchSet='onInputSearchSet'
                @InputSearchClear='onInputSearchClear'
            />
        </template>

        <template #content>
            <form>
                <fieldset class="bottom-space">
                    <p>
                        {{ Language.say('settings.blacklist.content.inbox_blacklist') }}
                    </p>

                    <ContainerAlert
                        :type="(disable_add) ? 'warning' : 'info'"
                    >
                        {{Language.say('settings.blacklist.notices.usage_1')}}
                        <strong> {{ senders_list.count  }}</strong> {{Language.say('settings.blacklist.notices.usage_2')}}
                        <strong> {{  AccountController.account.cos.max_blacklist_entries }}</strong> {{Language.say('settings.blacklist.notices.usage_3')}}
                    </ContainerAlert>

                    <PremiumSubscribe v-if="AccountController.account.premium.allowed && disable_add"
                        :text="'settings.blacklist.notices.upgrade_message'"
                        :gtm="{
                            module : 'blacklist_settings',
                            feature: 'blacklist_list',
                            block  : 'pre_content',
                            action : 'premium_subscribe'
                        }"
                    />

                    <div class="double-top-space control-group" v-if="senders_list.count">
                        <div class="control check-group white-list">
                            <div class="item">
                                <span>
                                    {{ Language.say("settings.blacklist.content.senders") }}
                                </span>


                                <span>
                                    {{ Language.say("settings.blacklist.content.rule") }}
                                </span>
                            </div>

                            <SmartList
                                @smartListItemsSet=onSmartListItemsSet
                                :smart_list_items="senders_list.items">
                                    <template #elements>
                                        <template v-for="(blacklist) in smart_list_items"
                                            :key="blacklist.sender"
                                        >
                                            <div
                                                class="item"
                                            >
                                                <span>
                                                    {{ blacklist.sender }}
                                                </span>
                                                <span>
                                                    {{ Language.say(`settings.blacklist.content.${blacklist.rule}`) }}
                                                </span>
                                                <ActionButton
                                                    @click="onRemoveBlacklistSender(blacklist.sender)"
                                                    v-tooltip='`settings.blacklist.actions.remove_${blacklist.rule}`'

                                                    icon="fas fa-trash"
                                                    :loading="antispam_controller.saving_state.saving[blacklist.sender]"
                                                />
                                            </div>
                                        </template>
                                    </template>
                            </SmartList>
                        </div>
                    </div>
                    <div class="top-space" v-if="senders_list.count === 0">
                        <p>{{ Language.say("settings.blacklist.content.blacklist_empty") }}</p>
                    </div>
                </fieldset>
            </form>
        </template>
    </SectionViewLayout>
</template>

<script setup>
    import {reactive, onBeforeMount, ref} from 'vue';
    import SectionViewLayout              from '@/vue/Layouts/Sections/SectionViewLayout.vue';
    import ActionButton                   from '@/vue/Elements/Buttons/ActionButton.vue';
    import RouterButton                   from '@/vue/Elements/Buttons/RouterButton.vue';
    import InputSearch                    from '@/vue/Elements/Inputs/InputSearch.vue';
    import SmartList                      from '@/vue/Elements/Tools/SmartList.vue';
    import ContainerAlert from '@/vue/Elements/Content/ContainerAlert.vue';
    import AccountController              from '@/js/Webmail/AccountController';
    import AntiSpamController             from '@/js/Settings/AntiSpam/AntiSpamController.js';
    import Language                       from '@/js/Shared/Language/Language.js';
    import PremiumSubscribe               from '../../Webmail/Partials/Premium/PremiumSubscribe.vue';

    const props = defineProps({
        antispam_controller: AntiSpamController,
    });

    const smart_list_items = ref();
    const search_active    = ref(false);
    const senders_list     = ref({});
    const disable_add      = ref(false);

    props.antispam_controller.content_state.onErrorRetry(async () => {
        await fetchBlacklist();
        setSendersList();
        setDisableAdd();
    })

    onBeforeMount(async () => {
        await fetchBlacklist();
        setSendersList();
        setDisableAdd();
    })

    const fetchBlacklist = async () => {
        await props.antispam_controller.fetchBlacklistOnce()
    }

    const onRemoveBlacklistSender = async (sender) => {
        await props.antispam_controller.removeBlacklistSender(sender);
        setDisableAdd();
    }

    const onSmartListItemsSet = (items) => {
        setSmartListItems(items);
    }

    const onSearchToggle = () => {
        search_active.value = !search_active.value;
    }

    const onInputSearchSet = (search_value) => {
        props.antispam_controller.data.blacklist.search(search_value);
        setSearchList();
    }

    const onInputSearchClear = () => {
        props.antispam_controller.data.blacklist.search_list.reset();
        setSendersList();
    }

    const setSmartListItems = (items) => {
        smart_list_items.value = items;
    }

    const setSendersList = () => {
        senders_list.value = props.antispam_controller.data.blacklist;
    }

    const setSearchList = () => {
        senders_list.value = props.antispam_controller.data.blacklist.search_list;
    }

    const setDisableAdd = () => {
        if (props.antispam_controller.data.blacklist.count >= AccountController.account.cos.max_blacklist_entries) {
            disable_add.value = true;
            return;
        }

        disable_add.value = false;
    }
</script>
